<template>
    <Row type="none" class="bg-white rounded shadow">

        <Modal
            id="modal_show"
            :text="modalText"
        />
        <div v-if="alertInvalidImage"  class="container">
            <Alert class="text-center" :variant="'danger'">{{ alertText }}</Alert>
        </div>

        <RowColumn >
            <FormTag v-if="getUser.person.employeeInformation">
                <div class="grid grid-cols-12 gap-3 container mt-5">
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-8 ml-2">
                            {{ $t('person.givenName') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            :no-margin-top="true"
                            check-to-model="modelNotEmptyState"
                            model-name="givenName"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-8 ml-2">
                            {{ $t('person.familyName') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            model-name="familyName"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-8 ml-2">
                            {{ $t('company.telephone') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            :no-margin-top="true"
                            check-to-model="modelNotEmptyState"
                            model-name="telephone"
                        />
                    </div>
                </div>

                <div class="grid grid-cols-12 gap-3 container my-5">
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute -top-4 ml-2">
                            {{ $t('user.email') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            :no-margin-top="true"
                            check-to-model="modelEmailState"
                            model-name="email"
                            type="email"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div>
                            <label for="image" class="btn btn-primary w-full h-11">
                                <span
                                    v-if="isLoadingError"
                                    class="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                >
                                </span>
                                <span class="font-bold">{{ $t('image.choiceImageFile') }}</span>
                            </label>
                            <input
                                id="image"
                                style="display: none"
                                type="file"
                                accept="image/*"
                                @change="importImage($event)"
                            >
                            <span
                                v-if="modelForm.image"
                                class="d-inline-block ml-2 pt-2 text-primary text-truncate"
                                style="max-width: 250px;"
                            >
                                {{ file.name }}
                            </span>
                        </div>
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <!-- submit -->
                        <SubmitRow :do-action="editEmployee" :is-disabled="hasErrors" :is-loading="isLoading" text="edit" class="mb-3" sm-size="12" md-size="12" />
                    </div>
                </div>

            </FormTag>
            <FormTag v-else>
                <div class="grid grid-cols-12 gap-3 container mt-5">
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('company.name') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            :no-margin-top="true"
                            check-to-model="modelNotEmptyState"
                            model-name="name"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('person.givenName') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            :no-margin-top="true"
                            check-to-model="modelNotEmptyState"
                            model-name="givenName"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('person.familyName') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            model-name="familyName"
                        />
                    </div>
                </div>

                <div class="grid grid-cols-12 gap-3 container mt-5">
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('company.telephone') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            :no-margin-top="true"
                            check-to-model="modelNotEmptyState"
                            model-name="telephone"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('user.email') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <InputBox
                            class="px-0"
                            :errors="errors"
                            :model-form="modelForm"
                            :no-margin-top="true"
                            check-to-model="modelEmailState"
                            model-name="email"
                            type="email"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('companyRequisites.baseCurrency') }}<span class="text-red-500 text-xl">*</span>
                        </div>
                        <v-select
                            class="px-0"
                            :clearable="false"
                            :options="getCurrencies"
                            :reduce="options => options.shortName"
                            label="shortName"
                            v-model="modelForm.baseCurrency"
                        >
                            <template #no-options="{}">
                                {{ $t("selectError") }}
                            </template>
                        </v-select>
                    </div>
                </div>

                <div class="grid grid-cols-12 gap-3 container mt-5">
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('companyRequisites.addTin') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="tin"
                            check-to-model="modelIntOrEmpty"
                            :model-form="modelForm"
                            :errors="errors"
                            :no-margin-top="true"
                        />
                    </div>
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                            {{ $t('companyRequisites.addGceo') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="gceo"
                            check-to-model="modelIntOrEmpty"
                            :model-form="modelForm"
                            :errors="errors"
                            :no-margin-top="true"
                        />
                    </div>

                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="grid grid-cols-12 gap-3">
                            <div class="col-span-4">
                                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                                    {{ $t('sale.tax.title') }}
                                </div>
                                <v-select
                                    class="px-0 text-xs"
                                    :placeholder="$t('sale.tax.withoutTax')" :options="getTaxes"
                                    :get-option-label="option => option.name + ' ' + parseFloat(option.percent) + '%'"
                                    :reduce="options => options['@id']"
                                    v-model="modelForm.tax"
                                >
                                    <template #no-options="{}">
                                        {{ $t("selectError") }}
                                    </template>
                                </v-select>
                            </div>
                            <div class="col-span-8">
                                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute bottom-9 ml-2">
                                    {{ $t('customer.type') }}
                                </div>
                                <v-select
                                    class="px-0 text-xs"
                                    :disabled="modelForm.tax === null"
                                    :clearable="false"
                                    :options="[{label: $t('sale.tax.inPrice'), value: true}, {label: $t('sale.tax.onPrice'), value: false}]"
                                    label="label"
                                    :reduce="options => options.value"
                                    v-model="modelForm.isTaxInPrice"
                                >
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid grid-cols-12 gap-3 container mt-5">
                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute -top-3 ml-2">
                            {{ $t('companyRequisites.legalAddress') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="legalAddress"
                            :model-form="modelForm"
                            :errors="errors"
                            :no-margin-top="true"
                        />
                    </div>

                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 position-absolute -top-3 ml-2">
                            {{ $t('companyRequisites.physicalAddress') }}
                        </div>
                        <InputBox
                            class="px-0"
                            model-name="physicalAddress"
                            :model-form="modelForm"
                            :errors="errors"
                            :no-margin-top="true"
                        />
                    </div>

                    <div class="col-span-12 md:col-span-4 position-relative pl-0">
                        <div>
                            <label for="image" class="btn btn-primary w-full h-11">
                                <span
                                    v-if="isLoadingError"
                                    class="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                >
                                </span>
                                <span class="font-bold">{{ $t('image.choiceImageFile') }}</span>
                            </label>
                            <input
                                id="image"
                                style="display: none"
                                type="file"
                                accept="image/*"
                                @change="importImage($event)"
                            >
                            <span
                                v-if="modelForm.image"
                                class="d-inline-block ml-2 pt-2 text-primary text-truncate"
                                style="max-width: 250px;"
                            >
                                {{ file.name }}
                            </span>
                        </div>
                    </div>
                </div>


                <div class="container mt-3 mb-5">
                    <!-- submit -->
                    <SubmitRow :do-action="editCompany" :is-disabled="hasErrors" :is-loading="isLoading" text="edit" class="mb-3" />
                </div>
            </FormTag>
        </RowColumn>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "../../mixin/validatorMixin";
import loginMixin from "../../mixin/loginMixin";
import RowColumn from "../../components/RowColumn";
import FormTag from "../../components/html/FormTag";
import InputBox from "../../components/InputBox";
import Row from "../../components/html/Row";
import SubmitRow from "../../components/SubmitRow";
import Modal from "@/components/html/Modal";
import vSelect from "vue-select";
import '../../style/vue-select.css';
import Alert from "@/components/html/Alert.vue";

export default {
    name: "CompanyAdd",
    mixins: [validatorMixin, loginMixin],
    components: {Alert, Modal, SubmitRow, Row, InputBox, FormTag, RowColumn, vSelect},
    data() {
        return {
            appUrl: process.env.VUE_APP_API_URL,
            modalText: '',
            alertText: '',
            isLoading: false,
            isLoadingError: false,
            file: '',
            alertInvalidImage: false,
            errors: {
                companyName: null,
                givenName: null,
                email: null,
                plainPassword: null,
                telephone: null,
            },
            breadcrumbItems: [
                {name: 'home', url: ""},
                {name: 'company.title', url: "company"},
                {name: 'edit'},
            ],
            modelForm: {
                email: '',
                familyName: null,
                givenName: null,
                tax: null,
                isTaxInPrice: false,
                name: null,
                telephone: null,
                tin: null,
                gceo: null,
                legalAddress: null,
                physicalAddress: null,
                chiefDirector: null,
                baseCurrency: null,
                image: null,
            },
        }
    },
    computed: {
        ...mapGetters(['isEmailAvailable', 'getCurrencies', 'getTaxes', 'getCurrencyByShortName', 'getUser']),
    },
    methods: {
        ...mapActions([
            'checkEmailAvailability',
            'setBreadcrumbItems',
            'pushEmployeeImage',
            'updateCompanyRequisites',
            'fetchUser',
            'putEmployee'
        ]),
        importImage(event) {
            this.alertInvalidImage = false
            this.isLoadingError = true
            this.file = event.target.files[0]

            const data = new FormData();

            data.append('file', this.file)

            this.pushEmployeeImage(data)
                .then((res) => {
                    this.modelForm.image = res['@id']

                    setTimeout(() => this.isLoadingError = false, 3000)
                })
                .catch((err) => {
                    this.isLoadingError = false;

                    if (err === 'file: Please upload a valid image') {
                        this.alertText = this.$t('image.validImage')
                    } else {
                        this.alertText = err
                    }

                    this.alertInvalidImage = true
                    this.file = null
                })
        },
        isEmailChanged() {
            if (this.modelForm.email !== this.getUser.email) {
                this
                    .checkEmailAvailability(this.modelForm.email)
                    .then(() => {
                        if (!this.isEmailAvailable) {
                            this.isLoading = false
                            this.modalText = this.$t("user.errors.emailExists")
                            this.$bvModal.show('modal_show')
                            return
                        }

                        this.modelForm.people = [{
                            '@id': this.getUser.person['@id'],
                            'image': this.modelForm.image,
                            'user': {
                                '@id': this.getUser['@id'],
                                'email': this.modelForm.email
                            },
                            'familyName': this.modelForm.familyName,
                            'givenName': this.modelForm.givenName,
                            'telephone': this.modelForm.telephone,
                        }]

                        this.makeData()
                        this
                            .updateCompanyRequisites(this.modelForm)
                            .then(() => {
                                this.$root.showOverlay = false
                                this.$store.state.user.user.isNeedFetch = true
                                this.fetchUser()
                                this.$i18nHelper.toUrl('')
                            })
                            .catch(() => {
                                this.$root.showOverlay = false
                            })
                    })
                    .catch((reason) => {
                        if (reason === 'connectionRefused') {
                            this.modalText = this.$t('connectionRefused')
                            this.$bvModal.show('modal_show')
                        }

                        this.isLoading = false
                        this.$root.showOverlay = false
                    })
            } else {
                delete this.modelForm.email

                if (this.modelForm.image) {
                    this.modelForm.people = [{
                        '@id': this.getUser.person['@id'],
                        'image': this.modelForm.image,
                        'familyName': this.modelForm.familyName,
                        'givenName': this.modelForm.givenName,
                        'telephone': this.modelForm.telephone,
                    }]
                }

                this.makeData()
                this
                    .updateCompanyRequisites(this.modelForm)
                    .then(() => {
                        this.$root.showOverlay = false
                        this.$store.state.user.user.isNeedFetch = true
                        this.fetchUser()
                        this.$i18nHelper.toUrl('')
                    })
                    .catch(() => {
                        this.$root.showOverlay = false
                    })
            }
        },
        makeData() {
            if (typeof this.modelForm.tax === 'object') {
                this.modelForm.tax = this.modelForm.tax['@id']
            }

            if (this.modelForm.tin === '') {
                this.modelForm.tin = null
            }

            if (this.modelForm.gceo === '') {
                this.modelForm.gceo = null
            }

            this.modelForm.baseCurrency = this.getCurrencyByShortName(this.modelForm.baseCurrency)['@id']
        },
        editCompany() {
            this.$root.showOverlay = true

            this.isEmailChanged()
        },
        editEmployee() {
            this.makeEmployeeData()

            this.putEmployee(this.makeEmployeeData())
        },
        makeEmployeeData() {
            return  {
                id: this.getUser.person.id,
                givenName: this.modelForm.givenName,
                familyName: this.modelForm.familyName,
                telephone: this.modelForm.telephone,
                user: {
                    '@id': this.getUser['@id'],
                    email: this.modelForm.email
                },
                image: this.modelForm.image
            }
        }
    },
    created() {
        if (this.getUser.person.employeeInformation) {

            let breadcrumbItems = [
                {name: 'home', url: ""},
                {name: 'employee.title', url: "employees"},
                {name: 'edit'},
            ]

            this.setBreadcrumbItems(breadcrumbItems)
            return
        }

        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this
            .fetchUser()
            .then(() => {
                this.modelForm.name = this.getUser.person.company.name
                this.modelForm.givenName = this.getUser.person.givenName
                this.modelForm.familyName = this.getUser.person.familyName
                this.modelForm.telephone = this.getUser.person.telephone
                this.modelForm.email = this.getUser.email
                this.modelForm.baseCurrency = this.getUser.person.company.baseCurrency.shortName
                this.modelForm.tin = this.getUser.person.company.tin
                this.modelForm.gceo = this.getUser.person.company.gceo
                this.modelForm.tax = this.getUser.person.company.tax
                this.modelForm.isTaxInPrice = this.getUser.person.company.isTaxInPrice
                this.modelForm.legalAddress = this.getUser.person.company.legalAddress
                this.modelForm.physicalAddress = this.getUser.person.company.physicalAddress
            })
    }
}
</script>

<style scoped>

</style>